import Hidden from '@material-ui/core/Hidden';
import React from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";

import centerStyle from "./center";
import inteligente from "assets/EnergyCompany/img/inteligente.svg";
import moderno from "assets/EnergyCompany/img/moderno.svg";
import seguro from "assets/EnergyCompany/img/seguro.svg";
import simples from "assets/EnergyCompany/img/simples.svg";

const style = theme => ({
  centeredSection: {
    ...centerStyle(theme),
    color: "black",
  },
  sectionWrapper: {
    alignItems: "center",
    display: "flex",
    [theme.breakpoints.down("sm")]: {
      display: "block",
    },
  },
  disclaimerText: {
    flex: 1,
    "& h1": {
      fontWeight: "bold",
    },
    "& p": {
      fontSize: "20px",
      lineHeight: "1.5",
    },
    [theme.breakpoints.down("sm")]: {
      display: "block",
      textAlign: "center",
      "& h1": {
        fontSize: "2.5em",
      },
    },
  },
  infos1Wrapper: {
    alignItems: "flex-end",
    display: "flex",
    flexDirection: "column",
  },
  infos2Wrapper: {
    alignItems: "flex-end",
    display: "flex",
    flexDirection: "column",
    marginTop: "70px",
    [theme.breakpoints.down("sm")]: {
      marginTop: "0",
    },
  },
  infoCard: {
    alignItems: "center",
    boxShadow: "0px 2px 5px 0 #0000001F",
    borderRadius: "6px",
    display: "flex",
    flexDirection: "column",
    height: "230px",
    justifyContent: "center",
    margin: "0 0 20px 20px",
    padding: "20px",
    textAlign: "center",
    transition: "all 0.3s ease-in-out 0s",
    width: "260px",
    "&:hover": {
      transform: "scale3d(1.02, 1.02, 1.02)",
    },
    "& img": {
      width: "50px",
    },
    "& h4": {
      fontWeight: "500",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "20px",
      margin: "20px 0",
      width: "100%",
    },
  },
  main: {
    backgroundColor: "white",
    color: "black",
    padding: "200px 0 0",
  },
});

const Section1 = ({ classes }) => {
  const infos1 = [
    { icon: inteligente, text: "Informações sempre atualizadas para montar sua estratégia", title: "Inteligente" },
    { icon: moderno, text: "Todos os dados na nuvem, sempre disponíveis", title: "Moderno" },
  ];

  const infos2 = [
    { icon: seguro, text: "Dados criptografados", title: "Seguro" },
    { icon: simples, text: "Tudo o que você precisa em um só lugar", title: "Simples" },
  ];

  const renderInfos = infos => (
    infos.map((info, index) => (
      <div className={classes.infoCard} key={index}>
        <img alt={info.title} src={info.icon} />
        <h4>{info.title}</h4>
        <p>{info.text}</p>
      </div>
    ))
  );

  return (
    <main className={classes.main}>
      <section className={classes.centeredSection}>
        <div className={classes.sectionWrapper}>
          <div className={classes.disclaimerText}>
            <h1 id="sobre-nos">Sem dor de cabeça</h1>
            <Hidden smDown>
                <p>Esqueça as planilhas do Excel e relatórios na memória</p>
                <p>do seu computador. Com a Energy Company você tem</p>
                <p>todos os dados sempre a sua disposição, unificados em</p>
                <p>uma plataforma simples e intuitiva.</p>
                {/* <a>Ver planos</a> */}
            </Hidden>
            <Hidden smUp>
              <p>Esqueça as planilhas do Excel e relatórios na memória do seu computador. Com a Energy Company você tem todos os dados sempre a sua disposição, unificados em uma plataforma simples e intuitiva.</p>
            </Hidden>
          </div>
          <div className={classes.infos1Wrapper}>
            {renderInfos(infos1)}
          </div>
          <div className={classes.infos2Wrapper}>
            {renderInfos(infos2)}
          </div>
        </div>
      </section>
    </main>
  );
};

Section1.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(style)(Section1);



// WEBPACK FOOTER //
// ./src/views/LandingPage/partials/2-section.js